import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import { LOADER_TIMEOUT_TIME, ROLE, SWAL_SETTINGS, showFilterListAppointment, showFilterlist } from "../../../../utils/Constants";
import { capitalizeFirstLetter, extractTime, formateDate, formateDateWithMonth, getDateWithTime, handleServerValidations, removeSpecialCharacter, TrimText } from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import * as WalletService from "../../../center/services/wallet.services";
import { useFormik } from "formik";
import { DatePicker, Drawer } from "rsuite";
import CustomError from "../../../../utils/customError";
import * as Yup from "yup";
import { list, deletePatient, changeStatus, listAppointments, editAppointments, rescheduleAppointments, appointmentCancel } from "../../../doctor/services/patient.services";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import moment from "moment";

const UpcomingAppointmentsTables = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [List, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({column: "appointment_date", order: -1});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        // { title: t("sidebar_link_restaurant"), url: "" },
        { title: t("Patient Management"), url: "" },
    ];
    const [resetdate, setResetDate] = useState(false);
    const [openWithHeader, setOpenWithHeader] = useState(false);
    const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [getGlobalData, setGlobalData] = useState({});

    const myGlobalData = useSelector((state) => state.globalData);

    useEffect(() => {
        if (myGlobalData && myGlobalData?.data) {
            setGlobalData(myGlobalData?.data);
        }
    }, [myGlobalData]);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                formData.append("isUpcomingAppointments", true);
                listAppointments(formData, ROLE.SUPER_ADMIN)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data.data.list : []);
                        //   console.log("data.data.data_ids", data.data.data_ids);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    const headerMapping = {
        appointment_register_id: "Appointment ID",
        patient_register_id: "Patient ID",
        patient_name: "Patient Name",
        center_name: "Center Name",
        doctor_name: "Doctor Name",
        appointment_date: "Appointment Date",
        appointment_time: "Appointment Time",
    };

    const handleExport = () => {
        const formData = new FormData();
        formData.append("page", 1);
        formData.append("per_page", datalength);
        formData.append("sort", JSON.stringify({}));
        formData.append("search", JSON.stringify({}));
        formData.append("global_search", globalsearch);
        formData.append("isUpcomingAppointments", true);

        listAppointments(formData, ROLE.SUPER_ADMIN)
            .then((data) => {
                setDataLength(data.data.total_records);
                const listData = data && data.data && data.data.list ? data.data.list : [];
                const printData = listData.map((item) => {
                    const transformedItem = {};
                    const AppointmentID = item?.appointment_register_id ? "#" + item?.appointment_register_id : "-";
                    const PatientID = item?.patient_register_id ? "#" + item?.patient_register_id : "-";
                    const PatientName = capitalizeFirstLetter(item?.patient_name) || "N/A";
                    const CenterName = item?.center_name ? capitalizeFirstLetter(item?.center_name) : "N/A";
                    const doctorName = item?.doctor_name || "N/A";
                    const appointmentDate = formateDate(item?.appointment_date) || "N/A";
                    const AppointmentTime = extractTime(item?.appointment_date) || "N/A";
                    // const AppointmentTime = capitalizeFirstLetter(item?.start_time) || "N/A";

                    for (const key in headerMapping) {
                        if (headerMapping.hasOwnProperty(key)) {
                            const newKey = headerMapping[key];
                            switch (key) {
                                case "appointment_register_id":
                                    transformedItem[newKey] = AppointmentID;
                                    break;
                                case "patient_register_id":
                                    transformedItem[newKey] = PatientID;
                                    break;
                                case "patient_name":
                                    transformedItem[newKey] = PatientName;
                                    break;
                                case "center":
                                    transformedItem[newKey] = CenterName;
                                    break;
                                case "center_name":
                                    transformedItem[newKey] = CenterName;
                                    break;
                                case "doctor_name":
                                    transformedItem[newKey] = doctorName;
                                    break;
                                case "appointment_date":
                                    transformedItem[newKey] = appointmentDate;
                                    break;
                                case "appointment_time":
                                    transformedItem[newKey] = AppointmentTime;
                                    break;
                                default:
                                    console.warn(`Unexpected key in headerMapping: ${key}`);
                                    transformedItem[newKey] = "N/A";
                                    break;
                            }
                        }
                    }
                    return transformedItem;
                });
                const ws1 = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws1, "Patient List");
                const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
                saveAs(blob, "UpcomingAppointments.xlsx");
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
            })
            .catch((error) => {
                setTimeout(() => {
                    setLoader(false);
                }, LOADER_TIMEOUT_TIME);
                console.log("error ====> ", error);
            });
    };

    // sorting function start
    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    };
    // sorting end

    // search or filter function
    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
        params.pgno = 1;
    };
    // search or filer end

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        setResetDate(!resetdate);
        params.pgno = 1;
    };

    // useEffect(() => {
    //     if (params.pgno && parseInt(params.pgno) !== 1) {
    //         navigate("/admin/report-management/patient/list/1", { replace: true });
    //     }
    // }, []);

    const validationSchema = Yup.object().shape({
        appointment_date: Yup.string()
            .required("Appointment date is required")
            .test("is-future-date", "Appointment date cannot be in the past", function (value) {
                if (!value) return false;
                const today = moment().startOf("day");
                const selectedDate = moment(value, "YYYY-MM-DD");
                return selectedDate.isSameOrAfter(today);
            }),
        startTime: Yup.string().trim().required("Start time is required"),
    });

    const addForm = useFormik({
        initialValues: {
            appointment_date: "",
            startTime: "",
            appointment_id: "",
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            let formData = new FormData();
            formData.append("appointment_id", values.appointment_id);
            formData.append("appointment_date", values.appointment_date);
            formData.append("start_time", values.startTime);
            rescheduleAppointments(formData, ROLE.SUPER_ADMIN)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        resetForm({ values: "" });
                        // navigate(`/admin/appointment/list/1`);
                        setShowModal(false);
                        setStatusUpdate(!statsupdate);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        setShowModal(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                });
        },
    });

    const handleClose = () => {
        setShowModal(false);
        addForm.resetForm();
    };

    const handleStartTimeChange = (e) => {
        addForm.setFieldTouched("startTime", true);
        const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
        if (match && match[0]) {
            const parts = match[0].split(":");
            const hours = parts[0];
            const minutes = parts[1];
            const seconds = parts[2] || "00";
            addForm.setFieldValue("startTime", `${hours}:${minutes}:${seconds}`);
        }
    };

    const cancelAppointment = (id) => {
        const formData = new FormData();
        formData.append("appointment_id", id);
        formData.append("status", "canceled");
        Swal.fire({
            customClass: "swal-wide",
            title: t("admin.cafes.msg_are_you_sure"),
            text: t("Do you really want to cancel the appointment."),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("admin.cafes.btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("admin.cafes.btn_yes"),
        }).then((result) => {
            if (result.isConfirmed) {
                appointmentCancel(formData, ROLE.SUPER_ADMIN)
                    .then((response) => {
                        if (response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                            setStatusUpdate(!statsupdate);
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error===>");
                    });
            }
        });
    };

    return (
        <>
            {/* <Breadcrums data={breadcrumbs} /> */}
            {/* table section */}
            <div className="animation_fade">
                <div className="row">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">{/* {t("Medicine Management")} */}</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                                            onChange={(e) => {
                                                setGlobalSearch(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="me-3">
                                    <CustomRangepicker
                                        GetDateRange={(e) => {
                                            prepareSearch("appointment_date", e);
                                        }}
                                        resetdate={resetdate}
                                    />
                                </div>
                                {/* <div className="me-3">
                  <StatusFilter
                    data={showFilterListAppointment}
                    prepareSearch={prepareSearch}
                  />
                </div>  */}
                                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                    {t("admin.filter_placeholder.btn_reset_filter")}
                                </button>
                                {/* <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/medicine-management/medicine/add`)
                  }
                >
                  {t("admin.cafes.btn_add_new")}
                </button> */}
                                <button className="btn ripple btn-main-primary signbtn mr-2" onClick={handleExport} disabled={datalength === 0}>Export Report</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Appointment ID</th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>{t("Patient ID")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="patient_register_id" />
                                            </div>
                                        </th>
                                        <th>
                                            <div className="sorting_column">
                                                <span>{t("Patient Name")}</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="name" />
                                            </div>
                                        </th>
                                        <th>Center Name</th>
                                        <th>Doctor Name</th>
                                        <th>Appointment Date</th>
                                        <th>Appointment Time</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan={14}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {List.length ? (
                                                List.map((row, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>{(page-1) * itemperpage + i + 1}</td>
                                                            <td>{row?.appointment_register_id ? "#" + row?.appointment_register_id : null}</td>
                                                            <td>{row?.patient_register_id ? "#" + row?.patient_register_id : null}</td>
                                                            <td>
                                                                {row?.patient_name ? (
                                                                    <div className="d-flex">{row?.patient_name ? capitalizeFirstLetter(TrimText(row.patient_name, 30)) : "N/A"}</div>
                                                                ) : (
                                                                    <div className="d-flex">N/A</div>
                                                                )}
                                                            </td>
                                                            <td>{row?.center_name ? capitalizeFirstLetter(row.center_name) : "N/A"}</td>
                                                            <td>{row?.doctor_name ? capitalizeFirstLetter(row.doctor_name) : "N/A"}</td>
                                                            <td>{formateDate(row?.appointment_date)}</td>
                                                            <td>{extractTime(row?.appointment_date)}</td>
                                                            {/* <td>{row?.start_time}</td> */}
                                                            <td>
                                                                <div className="d-flex">
                                                                    <button
                                                                        className="btn ripple btn-main-primary signbtn"
                                                                        onClick={() => {
                                                                            addForm.setFieldValue("appointment_id", row?._id);
                                                                            setShowModal(true);
                                                                        }}
                                                                    >
                                                                        Reschedule
                                                                    </button>
                                                                    <button className="btn btn-danger ms-2" onClick={() => cancelAppointment(row?._id)} disabled={row?.status === "canceled"}>
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={14} className="text-center">
                                                        {t("admin.message.msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="" id="example1_info" role="status" aria-live="polite">
                            <b>
                                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Patient Management",
                                        path: "/admin/management-section/upcoming-appointment/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`modal fade ${showModal ? "show" : ""}`}
                id="modalAddFund"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{
                    display: showModal ? "block" : "none",
                    overflow: "visible",
                    zIndex: 1050,
                }}
            >
                <div
                    className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
                    style={{
                        maxWidth: "500px",
                        marginTop: "-8%",
                        overflow: "visible",
                        zIndex: 1050,
                    }}
                >
                    <div
                        className="modal-content"
                        style={{
                            overflow: "visible",
                            zIndex: 1050,
                            position: "relative",
                        }}
                    >
                        {/* Modal Header */}
                        <div className="modal-header" style={{ overflow: "visible" }}>
                            <h5 className="modal-title" id="exampleModalLabel">
                                Reschedule Appointment
                            </h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body" style={{ overflow: "visible" }}>
                            <div className="cancel-modal-info gap-4">
                                <form onSubmit={addForm.handleSubmit}>
                                    <div className="row">
                                        {/* Date Picker */}
                                        <div className="col-lg-12 text-center form-group">
                                            <label className="text-left d-flex">
                                                {t("Appointment Date")}:<span className="requirestar">*</span>
                                            </label>
                                            <DatePicker
                                                oneTap
                                                classPrefix="restaurant"
                                                placeholder={t("Select appointment date")}
                                                placement="autoVertical"
                                                format="dd.MM.yyyy"
                                                cleanable={false}
                                                editable={false}
                                                name="appointment_date"
                                                container={() => document.body}
                                                menuStyle={{
                                                    position: "fixed",
                                                    zIndex: 9999,
                                                }}
                                                style={{ zIndex: 9999, position: "relative" }}
                                                onChange={(e) => {
                                                    const year = e.getFullYear();
                                                    const month = String(e.getMonth() + 1).padStart(2, "0");
                                                    const date = String(e.getDate()).padStart(2, "0");
                                                    addForm.setFieldTouched("appointment_date", true);
                                                    const formattedDate = `${year}-${month}-${date}`;
                                                    addForm.setFieldValue("appointment_date", formattedDate);
                                                }}
                                                value={addForm.values.appointment_date ? new Date(addForm.values.appointment_date) : null}
                                                onBlur={addForm.handleBlur}
                                                shouldDisableDate={(date) => {
                                                    const today = new Date();
                                                    today.setHours(0, 0, 0, 0);
                                                    return date < today;
                                                }}
                                            />
                                            <CustomError name="appointment_date" form={addForm} className="text-danger d-flex text-left" />
                                        </div>

                                        {/* Time Picker */}
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="text-left d-flex">
                                                        Start Time:
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <div className="mb-3">
                                                        <DatePicker
                                                            classPrefix="restaurant"
                                                            placement="autoVertical"
                                                            format="HH:mm"
                                                            cleanable={false}
                                                            editable={true}
                                                            name="openingTime"
                                                            container={() => document.body}
                                                            menuStyle={{
                                                                position: "fixed",
                                                                zIndex: 9999,
                                                            }}
                                                            style={{ zIndex: 9999, position: "relative" }}
                                                            onChange={handleStartTimeChange}
                                                            value={getDateWithTime(addForm.values.startTime)}
                                                            onBlur={addForm.handleBlur}
                                                            hideMinutes={(minute) => minute % 15 !== 0}
                                                        />
                                                        <CustomError name="startTime" form={addForm} className="text-danger" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div className="button-form">
                                        <button type="submit" className={`btn ripple btn-main-primary signbtn w-100 ${addSubmissionLoader ? "btn-loader" : ""}`}>
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            <div className={`modal-backdrop fade ${showModal ? "show" : ""}`} style={{ display: showModal ? "block" : "none", zIndex: 1040 }}></div>
        </>
    );
};

export default UpcomingAppointmentsTables;
